import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button
} from '@mui/material';

interface SectionData {
    title: string;
    order: number;
}

interface SectionModalProps {
    open: boolean;
    onClose: () => void;
    onSave: (data: SectionData) => void;
    initialData?: Partial<SectionData>;
    isEditing?: boolean;
}

const SectionModal: React.FC<SectionModalProps> = ({ open, onClose, onSave, initialData, isEditing = false }) => {
    const [data, setData] = useState<SectionData>({
        title: '',
        order: 0
    });
    const [titleError, setTitleError] = useState('');

    useEffect(() => {
        if (open) {
            if (initialData) {
                setData({
                    title: initialData.title || '',
                    order: initialData.order || 0
                });
            } else {
                setData({
                    title: '',
                    order: 0
                });
            }
            setTitleError('');
        }
    }, [open, initialData]);

    const handleSave = () => {
        if (!data.title.trim()) {
            setTitleError('Le titre est requis');
            return;
        }
        onSave(data);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{isEditing ? 'Modifier la section' : 'Ajouter une nouvelle section'}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Titre de la section"
                    fullWidth
                    required
                    value={data.title}
                    onChange={(e) => {
                        setData({ ...data, title: e.target.value });
                        if (titleError) setTitleError('');
                    }}
                    error={!!titleError}
                    helperText={titleError}
                />
                <TextField
                    margin="dense"
                    label="Order"
                    type="number"
                    fullWidth
                    value={data.order}
                    onChange={(e) => setData({ ...data, order: parseInt(e.target.value) || 0 })}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSave} variant="contained">
                    {isEditing ? 'Save Changes' : 'Create Section'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SectionModal;
